import { useEffect, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { progressTrackingService } from '../services/progressTrackingService';
export var useProgressTracking = function () {
    var getIdToken = useAuth().getIdToken;
    // Set up the token provider for the progress tracking service
    useEffect(function () {
        progressTrackingService.setTokenProvider(getIdToken);
    }, [getIdToken]);
    return useMemo(function () { return ({
        // Node Progress
        getNodeProgress: progressTrackingService.getNodeProgress.bind(progressTrackingService),
        updateNodeProgress: progressTrackingService.updateNodeProgress.bind(progressTrackingService),
        getMultipleNodeProgress: progressTrackingService.getMultipleNodeProgress.bind(progressTrackingService),
        updateNodePreferences: progressTrackingService.updateNodePreferences.bind(progressTrackingService),
        getProgressSummary: progressTrackingService.getProgressSummary.bind(progressTrackingService),
        // Learning Sessions
        startLearningSession: progressTrackingService.startLearningSession.bind(progressTrackingService),
        completeLearningSession: progressTrackingService.completeLearningSession.bind(progressTrackingService),
        getUserSessions: progressTrackingService.getUserSessions.bind(progressTrackingService),
        // Flashcard Progress
        updateFlashcardProgress: progressTrackingService.updateFlashcardProgress.bind(progressTrackingService),
        getFlashcardProgress: progressTrackingService.getFlashcardProgress.bind(progressTrackingService),
        getFlashcardsDueForReview: progressTrackingService.getFlashcardsDueForReview.bind(progressTrackingService),
        getUserFlashcardProgress: progressTrackingService.getUserFlashcardProgress.bind(progressTrackingService),
        // Quiz Progress
        recordQuizProgress: progressTrackingService.recordQuizProgress.bind(progressTrackingService),
        getQuizProgress: progressTrackingService.getQuizProgress.bind(progressTrackingService),
        getUserQuizProgress: progressTrackingService.getUserQuizProgress.bind(progressTrackingService),
        // User Goals
        createGoal: progressTrackingService.createGoal.bind(progressTrackingService),
        getUserGoals: progressTrackingService.getUserGoals.bind(progressTrackingService),
        updateGoal: progressTrackingService.updateGoal.bind(progressTrackingService),
        deleteGoal: progressTrackingService.deleteGoal.bind(progressTrackingService),
        // Analytics and Reporting
        getUserAnalytics: progressTrackingService.getUserAnalytics.bind(progressTrackingService),
        getNodeAnalytics: progressTrackingService.getNodeAnalytics.bind(progressTrackingService),
        getStreakData: progressTrackingService.getStreakData.bind(progressTrackingService),
        // Backward Compatibility
        getOrCreateNodeProgress: progressTrackingService.getOrCreateNodeProgress.bind(progressTrackingService),
        updateProgress: progressTrackingService.updateProgress.bind(progressTrackingService),
    }); }, []);
};
export default useProgressTracking;
